import ReportButton from "components/ReportDropdown/Report/ReportButton";
import Icon from "hardcover-ui/components/Icon";
import faFlag from "icons/solid/flag.svg";
import UserBookType from "types/UserBookType";

export default function FlagReviewButton({
  userBookId,
}: Readonly<{
  userBookId: UserBookType["id"];
}>) {
  return (
    <ReportButton
      objectId={userBookId}
      objectType="UserBook"
      description={`Review: #${userBookId}`}
      variant="ghost"
      size="sm"
    >
      <span className="sr-only">Report this review</span>
      <Icon icon={faFlag} size="md" />
    </ReportButton>
  );
}
